export default "__VITE_ASSET__dBSw6mxm__"